import { createElementBlock as l, openBlock as n, createElementVNode as t } from "vue";
import o from "../../../../_virtual/_plugin-vue_export-helper.js";
const r = {}, a = {
  fill: "none",
  viewBox: "0 0 20 20",
  xmlns: "http://www.w3.org/2000/svg"
};
function f(i, e) {
  return n(), l("svg", a, [...e[0] || (e[0] = [
    t("rect", {
      fill: "#E6541D",
      height: "20",
      rx: "4",
      width: "20"
    }, null, -1),
    t("path", {
      "clip-rule": "evenodd",
      d: "M3.82 7.08h4.551a.39.39 0 0 0-.004-.78H3.821a.39.39 0 0 0 0 .78Zm0 2.33h4.551a.39.39 0 0 0-.004-.78H3.821a.39.39 0 1 0 0 .78Zm4.551 2.33h-4.55a.39.39 0 0 1-.391-.39.39.39 0 0 1 .39-.388h4.547a.39.39 0 0 1 .39.39.39.39 0 0 1-.386.388Zm-4.55 2.33h4.55a.39.39 0 0 0-.004-.78H3.821a.39.39 0 1 0 0 .78Zm8.984-3.42V7.187a3.299 3.299 0 0 0 .172 6.592 3.297 3.297 0 0 0 3.293-3.125l-3.465-.004Zm.63-.601V6.924a3.298 3.298 0 0 1 3.126 3.125h-3.125Z",
      fill: "#fff",
      "fill-rule": "evenodd"
    }, null, -1)
  ])]);
}
const s = /* @__PURE__ */ o(r, [["render", f]]);
export {
  s as default
};
